export class NewHireEnrollmentRoutes {

	public static readonly EmployeeRecord = '/employee-record';

	public static readonly WhoWillEnroll = '/who-will-enroll';

	public static readonly BenefitEnrollment = '/benefit-enrollment';

	public static readonly Coverage = '/coverage';

	public static readonly Retirement = '/retirement-plans';

	public static readonly Review = '/review';

	public static readonly Confirmation = '/confirmation';

	public static readonly Pension = '/pension';

	public static readonly NonTecClergy = '/non-tec-cleargy';

}